import React from "react";

import TemplateCard from "./TemplateCard";
import { DefaultTabs } from "./tabs/default";
import { RecruitmentTabs } from "./tabs/recruiter";
import { RocketLaunchIcon } from "@heroicons/react/24/outline";

export default function RecruiterCard({
  setProjectsVisible,
  authenticatedResources,
}) {
  const tabOptions = {
    Home: RecruitmentTabs.Home(authenticatedResources),
    Publications: DefaultTabs.Publications(),
    Projects: DefaultTabs.Projects(setProjectsVisible, authenticatedResources),
    Contact: RecruitmentTabs.Contact(authenticatedResources),
  };
  const startingTab = "Home";
  return (
    <div className="flex flex-col gap-4 h-full sm:h-auto items-center">
      <div className="relative inline-flex gap-4 items-center w-full max-w-4xl bg-green-500 bg-opacity-30 p-2 border-2 border-green-800  text-green-200  font-semibold rounded-lg transparent whitespace-break-spaces">
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full" />
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-ping" />
        <RocketLaunchIcon class="hidden sm:block w-5 h-5" />
        <p>
          I am excited to announce that I'll be interning with Citadel
          Securities this summer!
        </p>
      </div>
      <TemplateCard tabOptions={tabOptions} startingTab={startingTab} />
    </div>
  );
}
